export default __webpack_public_path__ + "static/media/drawing-desk-2.ef5aa540.jpg";